import useSWR, { SWRConfiguration } from 'swr'
import { useAuth } from '@web/walter-lib/auth'
import { restKeys, socketKeys } from '~api/swr/keys'

let isLogoutLoading = false

export const useAuthSwr = <T>(
    key: restKeys | socketKeys | Record<string, any> | null,
    cb: (data: unknown) => Promise<T>,
    swrConfig?: SWRConfiguration
) => {
    const { isAuth, logout } = useAuth()
    const { data, isLoading, isValidating, error, mutate } = useSWR<T>(isAuth ? key : null, cb, swrConfig)

    if (error?.response?.status === 401 || error?.code === 1002 || error?.code === 1004 || error?.code === 1005) {
        if (!isLogoutLoading) {
            isLogoutLoading = true
            logout(true)
        }
    }

    return { data, isLoading, isValidating, error, mutate }
}
